import React, { useEffect, useState } from "react";

import {
  FaCheckCircle,
  FaUsers,
  FaAward,
  FaLaptop,
  FaHeadset,
  FaChartLine,
  FaShieldAlt,
  FaArrowRight,
  FaStar,
} from "react-icons/fa";

import AOS from "aos";
import "aos/dist/aos.css";

import "./About.css";
import { BASE_URL } from "../../Config/config";

export default function About() {
  /* =====================================================
     ABOUT IMAGES
  ===================================================== */

  const [aboutImages, setAboutImages] = useState([]);
  const [aboutImagesLoading, setAboutImagesLoading] = useState(true);

  /* =====================================================
     FETCH ABOUT IMAGES
  ===================================================== */

  useEffect(() => {
    fetchAboutImages();
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);
  const fetchAboutImages = async () => {
    try {
      setAboutImagesLoading(true);

      const response = await fetch(`${BASE_URL}/about.php?action=get`);

      if (!response.ok) {
        throw new Error(`About API returned ${response.status}`);
      }

      const text = await response.text();

      let result;

      try {
        result = JSON.parse(text);
      } catch (error) {
        console.error("Invalid About API Response:", text);
        setAboutImages([]);
        return;
      }

      if (result.status && Array.isArray(result.data)) {
        setAboutImages(result.data);
      } else {
        setAboutImages([]);
      }
    } catch (error) {
      console.error("Fetch About Images Error:", error);
      setAboutImages([]);
    } finally {
      setAboutImagesLoading(false);
    }
  };

  /* =====================================================
     IMAGE URL
  ===================================================== */

  const getImageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http://") || image.startsWith("https://")) {
      return image;
    }

    return `${BASE_URL}/${image.replace(/^\/+/, "")}`;
  };

  /* =====================================================
     HIGHLIGHTS
  ===================================================== */

  const highlights = [
    "Professional software implementation",
    "Complete accounting and ERP solutions",
    "Reliable technical support",
    "Customized business solutions",
    "GST and business compliance support",
    "Long-term customer assistance",
  ];

  /* =====================================================
     VALUES
  ===================================================== */

  const values = [
    {
      icon: <FaLaptop />,
      title: "Smart Technology",
      description:
        "We provide modern and reliable software solutions designed around the practical needs of businesses.",
    },
    {
      icon: <FaUsers />,
      title: "Customer First",
      description:
        "We believe in understanding our customers and providing solutions that genuinely solve their business problems.",
    },
    {
      icon: <FaHeadset />,
      title: "Expert Support",
      description:
        "Our experienced support team is always ready to assist with implementation, training and technical issues.",
    },
    {
      icon: <FaChartLine />,
      title: "Business Growth",
      description:
        "Our goal is to help businesses improve productivity, accuracy and efficiency through technology.",
    },
  ];

  return (
    <main className="about-page">
      {/* =====================================================
          PAGE HERO
      ===================================================== */}

      {/* <section className="contact-hero">
        <div className="contact-hero-overlay"></div>

        <div className="section-container contact-hero-content">
          <span
            className="section-label"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            ABOUT US
          </span>

          <h1 data-aos="fade-up" data-aos-delay="150" data-aos-duration="900">
            We build reliable Tally ERP systems for
            <span> Growing businesses</span>
          </h1>

          <p data-aos="fade-up" data-aos-delay="300" data-aos-duration="900">
            Star Computers partners with finance and operations teams to design
            Tally ERP implementations that are accurate, compliant, and easy to
            use.
          </p>
        </div>
      </section> */}

      {/* =====================================================
          ABOUT HERO
      ===================================================== */}

      <section className="about-hero">
        <div className="about-hero-bg-circle"></div>

        <div className="section-container about-hero-container">
          <div
            className="about-hero-content"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <span className="section-label">ABOUT STAR COMPUTERS</span>

            <h1>
              Technology That Helps
              <span> Your Business Grow</span>
            </h1>

            <p>
              Star Computers is a trusted technology and software solutions
              provider helping businesses simplify accounting, automate
              operations and improve productivity with reliable technology.
            </p>

            <div className="about-hero-buttons">
              <a href="#our-story" className="about-primary-btn">
                Discover Our Story
                <FaArrowRight />
              </a>

              <a href="#contact" className="about-secondary-btn">
                Talk to Our Experts
              </a>
            </div>
          </div>

          <div
            className="about-hero-visual"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="about-main-circle">
              <div className="about-circle-inner">
                <FaLaptop />
              </div>

              <div className="about-floating-card about-card-one">
                <FaUsers />

                <div>
                  <strong>2000+</strong>
                  <span>Clients</span>
                </div>
              </div>

              <div className="about-floating-card about-card-two">
                <FaAward />

                <div>
                  <strong>10+</strong>
                  <span>Years Experience</span>
                </div>
              </div>

              <div className="about-floating-card about-card-three">
                <FaShieldAlt />

                <div>
                  <strong>98%</strong>
                  <span>Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          OUR STORY
      ===================================================== */}

      <section className="about-story-section" id="our-story">
        <div className="section-container">
          <div className="about-story-grid">
            {/* =================================================
                LEFT IMAGE
            ================================================= */}

            <div
              className="about-story-visual"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <div className="story-image-box">
                {aboutImagesLoading ? (
                  <div className="story-image-placeholder">
                    <FaLaptop />
                    <span>Loading...</span>
                  </div>
                ) : aboutImages.length > 0 ? (
                  <div className="about-story-image-wrapper">
                    <img
                      src={getImageUrl(aboutImages[0].image)}
                      alt="Star Computers"
                      className="about-story-image"
                    />
                  </div>
                ) : (
                  <div className="story-image-placeholder">
                    <FaLaptop />
                    <span>Star Computers</span>
                  </div>
                )}

                {/* EXPERIENCE CARD */}

                <div className="story-experience">
                  <strong>10+</strong>
                  <span>Years of Experience</span>
                </div>
              </div>
            </div>

            {/* =================================================
                RIGHT CONTENT
            ================================================= */}

            <div className="about-story-content">
              <span className="section-label">OUR STORY</span>

              <h2>
                Helping Businesses Work
                <span> Smarter Since Day One</span>
              </h2>

              <p>
                At Star Computers, we understand that every business is
                different. Our mission is to provide practical technology
                solutions that make everyday business operations simpler, faster
                and more efficient.
              </p>

              <p>
                From accounting and GST software to ERP, HRMS and customized
                business solutions, we help organizations choose, implement and
                maintain the right technology for their needs.
              </p>

              <div className="about-highlight-list">
                {highlights.map((item, index) => (
                  <div className="about-highlight" key={index}>
                    <FaCheckCircle />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          MISSION / VISION
      ===================================================== */}

      <section className="mission-section">
        <div className="section-container">
          <div
            className="mission-heading"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <span className="section-label">OUR PURPOSE</span>

            <h2>
              Driven By
              <span> Purpose & Technology</span>
            </h2>

            <p>
              We combine technology, expertise and customer support to help
              businesses achieve better results.
            </p>
          </div>

          <div className="mission-grid">
            <div
              className="mission-card mission-card-primary"
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="900"
            >
              <div className="mission-icon">
                <FaChartLine />
              </div>

              <h3>Our Mission</h3>

              <p>
                To empower businesses with dependable software and technology
                solutions that simplify operations, improve productivity and
                create long-term value.
              </p>
            </div>

            <div
              className="mission-card"
              data-aos="fade-left"
              data-aos-delay="300"
              data-aos-duration="900"
            >
              <div className="mission-icon">
                <FaStar />
              </div>

              <h3>Our Vision</h3>

              <p>
                To become a trusted technology partner for businesses by
                delivering innovative solutions, professional service and
                exceptional customer support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          OUR VALUES
      ===================================================== */}

      <section className="values-section">
        <div className="section-container">
          <div
            className="section-heading"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <span className="section-label">OUR VALUES</span>

            <h2>
              What Makes
              <span> Us Different</span>
            </h2>

            <p>
              We focus on more than just software. We focus on creating
              solutions that make a real difference to your business.
            </p>
          </div>

          <div className="values-grid">
            {values.map((value, index) => (
              <div
                className="value-card"
                key={index}
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay={index * 150}
              >
                <div className="value-icon">{value.icon}</div>

                <h3>{value.title}</h3>

                <p>{value.description}</p>

                <span className="value-number">0{index + 1}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
